// Label (Primitives; was primitives.tsx's, HIERARCHY follow-up 9, BL-189): a status word beside what it's
// about (DESIGN.md §2: status is drawn, not filled): muted for a kind or a state, a dashed underline for
// waiting on someone, red only for a problem, ink for what's happening now. It keeps base.css's classes
// (.flw-label, .flw-label-<kind>), which view sheets place by (.flw-tech > .flw-label). Reads only
// --label-*.
import type { ReactNode } from 'react';
import './Label.css';

export type LabelKind = 'muted' | 'wait' | 'bad' | 'now';

export interface LabelProps {
  kind?: LabelKind;
  children: ReactNode;
}

/** A status word: muted for kind and state, a dashed underline for waiting, red only for a problem. */
export function Label({ kind = 'muted', children }: LabelProps) {
  return <span className={`flw-label flw-label-${kind}`}>{children}</span>;
}
